module.exports = __webpack_public_path__ + "img/img5.6fd9d389.png";